export interface LocationData {
  latitude: number;
  longitude: number;
  timestamp?: string;
}

export type TrackingStreamPayload =
  | LocationData
  | { status: 'arrived' };

/** Interpreta o payload SSE do tracking (coordenadas ou fim do deslocamento). */
export function parseTrackingStreamPayload(
  raw: string,
): TrackingStreamPayload | null {
  try {
    const data = JSON.parse(raw) as Record<string, unknown>;
    if (data?.status === 'arrived') {
      return { status: 'arrived' };
    }
    const latitude = Number(data?.latitude);
    const longitude = Number(data?.longitude);
    if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) {
      return null;
    }
    return {
      latitude,
      longitude,
      timestamp:
        typeof data.timestamp === 'string' ? data.timestamp : undefined,
    };
  } catch {
    return null;
  }
}
